import { IAddComponentsToJobPayload } from 'bom/types';
import { IJobPart } from 'jobs/types';

import { IAddToJobFormData } from './types';

export const mapAddToJobData = (
  data: IAddToJobFormData,
  jobParts: IJobPart[]
): IAddComponentsToJobPayload => {
  const components = jobParts.map((part: IJobPart) => part.componentId);

  const componentsData = jobParts.reduce(
    (acc, part) => {
      acc[part.componentId] = {
        quantity: part.quantity,
        uom: part.uom,
      };

      return acc;
    },
    {} as { [key: number]: { quantity: number; uom: string } }
  );

  return {
    bomData: {
      projectId: data.project.id,
      jobName: data.jobName,
    },
    components,
    componentsData,
  };
};
